import { Routes, Route, Navigate, Outlet, useParams, useLocation } from 'react-router-dom'
import DocsLayout from '../components/layout/DocsLayout/DocsLayout'
import { VersionProvider } from '../hooks/useVersion'
import DocsContent from '../components/docs/DocsContent'
import { versions } from '../content/docs/config'
import { resolveVersion } from '../utils/version'

/**
 * Resolves the `:version` URL segment to the best matching available version
 * and redirects when the requested version is not an exact match.
 *
 * Example: /docs/v1.2.4/en/installation → /docs/v1.2.3/en/installation
 *          when v1.2.3 is the nearest available version ≤ v1.2.4.
 */
function VersionResolver() {
  const { version = 'latest', lang = 'en' } = useParams()
  const location = useLocation()

  const resolved = resolveVersion(version, versions)

  if (!resolved) {
    return <Navigate to='/docs/latest/en' replace />
  }

  if (resolved.version !== version) {
    const basePath = `/docs/${version}/${lang}`
    const rest = location.pathname.slice(basePath.length)
    return <Navigate to={`/docs/${resolved.version}/${lang}${rest}`} replace />
  }

  return <Outlet />
}

function DocsPage() {
  return (
    <VersionProvider>
      <Routes>
        {/* Redirect /docs to /docs/latest/en */}
        <Route index element={<Navigate to='latest/en' replace />} />

        {/* Version resolution + language routes */}
        <Route path=':version/:lang' element={<VersionResolver />}>
          {/* Pathless layout wrapper — rendered when version is resolved */}
          <Route element={<DocsLayout />}>
            <Route index element={<DocsContent docPath='index' />} />
            <Route path='installation' element={<DocsContent docPath='installation' />} />
            <Route path='user-management' element={<DocsContent docPath='user-management' />} />
            <Route path='application-manual' element={<DocsContent docPath='application-manual/index' />} />
            <Route path='application-manual/:section' element={<DocsContent docPath='application-manual' />} />
            <Route path='uninstallation' element={<DocsContent docPath='uninstallation' />} />
          </Route>
        </Route>
      </Routes>
    </VersionProvider>
  )
}

export default DocsPage
